import React, { useEffect } from 'react';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';
import {
  Form,
  Input,
  Row,
  SonForm,
  SubmitButton,
  TextParam,
  useForm,
} from '../../../_lib/Form2';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type ExternalLinksEditHeadlineForm = {
  form: SonForm<
    | TextParam<'title'>
  >;
};

export function ExternalLinksEditHeadlineForm({ form }: ExternalLinksEditHeadlineForm) {
  const { t } = useSonTranslation('ExternalLinks');
  const id = useHtmlValidId();
  const { delayedRefresh } = useRefreshBlock();

  const { formProps, params, fetchState } = useForm({ form, activateLeavingGuard: true });

  useEffect(() => {
    if (fetchState.type === 'success') {
      delayedRefresh();
    }
  }, [delayedRefresh, fetchState.type]);

  const titleParam = params.getByName('title');

  return (
    <Form id={`external-links-edit-headline-form-${id}`} {...formProps}>
      <Row>
        <Input label={t('edit.input.label')} param={titleParam} />
      </Row>
      <SubmitButton
        buttonLabel={t('edit.submitButton.text')}
        messageSuccess={t(`edit.status.success`)}
        messageSending={t(`edit.status.sending`)}
        messageFail={t(`edit.status.fail`)}
        fetchState={fetchState}
      />
    </Form>
  );
}
